module.exports = __webpack_public_path__ + "static/media/surveyFunnel.bee08a66.png";